require('/opt/odin/app/frontend/components/offers/offer/index.module.scss');module.exports = "../../app/cells/components/offers/offer/show.erb";